import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TourService', TourService);

  TourService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TourModalService',
    'SessionService',
  ];

  function TourService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TourModalService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'tours';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getTours: getTours,
      getTour: getTour,
      saveTour: saveTour,
      deleteTour: deleteTour,
      changeTourStatus: changeTourStatus,
      changeTourFeatured: changeTourFeatured,
      openTourListModal: openTourListModal,

      setDefaultAssociatedProvider: setDefaultAssociatedProvider,
      checkServiceItemsSchedulesApplied: checkServiceItemsSchedulesApplied,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getTours(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getTour(id, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTour(item) {
      var method = 'post';

      var url = apiUrl;
      if (item.id) {
        // edit
        url += '/' + item.id;
        method = 'put';
      }

      function success(response) {
        var msg = !item.id ? 'TOUR_ADDED' : 'TOUR_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { tour: item }, success, failure);
    }

    function deleteTour(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_TOUR',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'TOUR_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeTourStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeTourFeatured(item) {
      utils.changeItemFeatured(apiUrl + '/' + item.id, item);
    }

    function openTourListModal(websiteId) {
      // tourIds
      TourModalService.openTourListModal(websiteId);
    }

    function setDefaultAssociatedProvider(providerId, tourId, successCallback) {
      var url = apiUrl + '/' + tourId + '/set_default_associated_provider';

      return RestResource.request(
        'put',
        url,
        { provider_id: providerId },
        function () {
          var msg = $translate('DEFAULT_PROVIDER_CHANGED');
          utils._successMsg(msg);

          return successCallback(providerId);
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function checkServiceItemsSchedulesApplied(tour) {
      if (tour.service_items_cost_based) {
        if (tour.associated_service_items.length === 0) {
          return true;
        }

        for (var i = tour.associated_service_items.length - 1; i >= 0; i--) {
          if (tour.associated_service_items[i].appliedTo === 0) {
            return true;
          }
        }
      }

      return false;
    }
  }
})();
